// Used for caching the list of devices

import $api from '@/services/api';

export default {
  namespaced: true,
  state: {
    list: [],
    loading: false,
  },
  getters: {
    getLoading: (state) => {
      return state.loading;
    },
    getDevices: (state) => {
      return state.list;
    },
    getDevice: (state) => (deviceId) => {
      return state.list.find((device) => device.id === deviceId) || null;
    },
    getManufacturerDevices: (state) => (manufacturerId) => {
      return state.list.filter(
        (device) => device.manufacturer_id === manufacturerId,
      );
    },
    getTypeDevices: (state) => (typeId) => {
      return state.list.filter((device) => device.type_id === typeId);
    },
    getTypeManufacturerDevices: (_, getters) => (typeId, manufacturerId) => {
      const typeDevices = getters.getTypeDevices(typeId);
      return typeDevices.filter(
        (device) => device.manufacturer_id === manufacturerId,
      );
    },
  },
  mutations: {
    setDeviceList(state, val) {
      state.list = val;
    },
    setLoading(state, val) {
      state.loading = val;
    },
  },
  actions: {
    ensure({ state, dispatch }) {
      if (!state.list.length) {
        dispatch('fetch');
      }
    },
    // Load the device details and templates for the device
    async fetch({ state, commit }) {
      if (state.loading) return;
      commit('setLoading', true);

      try {
        const devices = await $api.get('/v1/internal/devices');
        devices.sort((a, b) => b.created.localeCompare(a.created));
        commit('setDeviceList', devices);
      } catch (err) {
        commit('setDeviceList', []);
      }
      commit('setLoading', false);
    },
  },
};
